// src/api/workoutSetting.js
import request from "./client";


export const MACHINE_KEY_BY_TITLE = {
    "레그익스텐션": "leg_extension",
    "시티드 레그프레스": "seated_leg_press",
    "시티드 레그컬": "seated_leg_curl",
    "시티드 체스트프레스": "seated_chest_press",
    "버터플라이": "butterfly",
    "인클라인 프레스": "incline_press",
    "랫풀다운": "lat_pulldown",
    "롱풀": "long_pull",
    "리어 델트플라이": "rear_delt_fly",
    "숄더프레스": "shoulder_press",
    "암컬": "arm_curl",
    "디핑": "dipping",
    "업도미널": "abdominal",
    "로타리 토르소": "rotary_torso",
    "이너/아웃싸이": "inner_outer_thigh",
};

const norm = (s) => String(s ?? "").toLowerCase().replace(/\s/g, "");

export function titleToMachineKey(title) {
    return MACHINE_KEY_BY_TITLE[title] ?? null;
}

export function titleToCardioType(title) {
    const t = norm(title);
    if (t.includes("러닝머신") || t.includes("트레드밀") || t.includes("treadmill")) return "treadmill";
    if (t.includes("자전거") || t.includes("사이클") || t.includes("cycle") || t.includes("bike")) return "cycle";
    if (t.includes("스텝머신") || t.includes("스텝퍼") || t.includes("stepper") || t.includes("계단")) return "stepper";
    return null;
}

export async function getMachineSettings() {
    return request("/settings/machines");
}

export async function getCardioSettings() {
    return request("/settings/cardio");
}


export async function saveMachineByTitle(title, payload) {
    const key = titleToMachineKey(title);
    if (!key) throw new Error(`알 수 없는 머신 제목: ${title}`);

    const first = Array.isArray(payload?.sets) ? payload.sets[0] : null;
    const body = {
        weight_kg: payload?.weight_kg ?? first?.weight_kg ?? null,
        reps: payload?.reps ?? first?.reps ?? null,
        sets: payload?.sets?.length ?? payload?.sets ?? null,
    };

    return request(`/settings/machines/${key}`, { method: "PUT", body });
}

export async function saveCardioByTitle(title, payload) {
    const type = titleToCardioType(title);
    if (!type) throw new Error(`알 수 없는 유산소 제목: ${title}`);

    const body = { duration_min: payload?.duration_min ?? null };

    if (type === "treadmill") {
        body.speed_kph = payload?.cardio?.speed_kph ?? null;
        body.distance_km = payload?.cardio?.distance_km ?? null;
        body.target_hr_bpm = payload?.cardio?.target_hr_bpm ?? null;
    } else {
        body.watt_w = payload?.cardio?.watt_w ?? payload?.cardio?.watt ?? null;
        body.target_hr_bpm = payload?.cardio?.target_hr_bpm ?? null;
    }

    return request(`/settings/cardio/${type}`, { method: "PUT", body });
}


export function mergeSettingsIntoWorkouts(list, machines, cardios) {
    const byMachine = Object.fromEntries((machines?.items ?? []).map(x => [x.machine_key, x]));
    const byCardio = Object.fromEntries((cardios?.items ?? []).map(x => [x.cardio_type, x]));

    return list.map(w => {
        const mkey = titleToMachineKey(w.title);
        if (mkey && byMachine[mkey]) {
            const s = byMachine[mkey];
            return {
                ...w,
                weight_kg: s.weight_kg ?? null,
                reps: s.reps ?? null,
                sets_count: s.sets ?? null,
                sets: s.sets
                    ? Array.from({ length: s.sets }).map((_, i) => ({
                        set_no: i + 1,
                        weight_kg: s.weight_kg ?? undefined,
                        reps: s.reps ?? undefined,
                    }))
                    : undefined,
            };
        }

        const ctype = titleToCardioType(w.title);
        if (ctype && byCardio[ctype]) {
            const s = byCardio[ctype];
            return {
                ...w,
                duration_min: s.duration_min ?? null,
                speed_kph: s.speed_kph ?? null,
                distance_km: s.distance_km ?? null,
                watt_w: s.watt_w ?? null,

                target_hr_bpm: s.target_hr_bpm ?? null,

                cardio: {
                    speed_kph: s.speed_kph ?? undefined,
                    distance_km: s.distance_km ?? undefined,
                    watt_w: s.watt_w ?? undefined,
                    target_hr_bpm: s.target_hr_bpm ?? undefined,
                },
            };
        }

        return w;
    });
}
